import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScreenForcing = () => {
  const location = useLocation();
  const isPdfReport = location?.pathname?.includes('/pdf-print');

  const setViewportMeta = content => {
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    if (viewportMeta?.content !== content) {
      viewportMeta.setAttribute('content', content);
    }
  };

  useEffect(() => {
    if (location.pathname === '/') {
      setViewportMeta('width=device-width, initial-scale=1');
    } else {
      if (!isPdfReport) setViewportMeta('width=992');
    }
  }, [location.pathname]);
};

export default useScreenForcing;
